module.exports = __webpack_public_path__ + "936d387355ab36321ea522e05c2e708b.pdf";